import axios from '../axios-config';
import { getCookies } from 'cookies-next';

/*
===============================|> All Cart APis <|===============================
01 |--> create cart,
02 |--> get cart,
03 |--> add item to cart,
04 |--> add bundle products to cart,
05 |--> update cart item,
06 |--> delete cart item,
07 |--> Aapply coupon,
08 |--> delete coupon,
09 |--> merge guest cart
10 |--> add product fees
11 |--> delete product fees
12 |--> validate voucher coupon
13 |--> apply voucher coupon
14 |--> clear cart if region changed
15 |--> check if all cart items available to checkout
===============================|> All Cart APis <|===============================
*/

// 01- ============= create cart
const createCart = async ({ mage }) => {
  let config = {
    method: 'post',
    url: '/cart/create',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- =============  get cart
const getCart = async ({ mage, quote }) => {
  let config = {
    method: 'get',
    url: '/cart/details/total',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 03- ============= Add item to cart
const addItemToCart = async ({
  mage,
  quote,
  sku,
  qty = '1',
  configurations = null,
  bundleItems = null,
}) => {
  let cartItem = {
    sku,
    qty: qty,
    quote_id: quote,
    ...(configurations
      ? {
        product_type: 'confiurable',
        product_option: {
          extension_attributes: {
            configurable_item_options: Object.values(configurations),
          },
        },
      }
      : {}),
    ...(bundleItems
      ? {
        product_option: {
          extension_attributes: {
            bundle_options: bundleItems,
          },
        },
      }
      : {}),
  };
  let config = {
    method: 'post',
    url: '/cart/add/items/v2',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({ cartItem }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04- ============= Add multi items to cart
const addMultiItemsToCart = async (mage, quote, skus) => {
  // const cartItems = skus.map((sku) => ({
  //   sku,
  //   qty: 1,
  // }));
  let config = {
    method: 'post',
    url: '/cart/multi/items',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({ cartItems: skus }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 05- ============= Update cart item
const updateCartItem = async (item_id, qty, mage, quote) => {
  let config = {
    method: 'put',
    url: `cart/update/items/${item_id}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({
      cartItem: { qty, item_id },
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 06- ============= Delete cart item
const deleteCartItem = async (item_id, mage, quote) => {
  let config = {
    method: 'delete',
    url: `cart/delete/items/${item_id}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 07- ============= Apply coupon code
const applyCoupon = async (mage, quote, couponCode) => {
  let config = {
    method: 'put',
    url: `/customer/applyCoupon/${couponCode}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 08- ============= Delete coupon
const deleteCoupon = async (mage, quote) => {
  let config = {
    method: 'delete',
    url: '/customer/deleteCoupon',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getCoupons = async (mage) => {
  let config = {
    method: 'get',
    url: '/customer/sales-coupon',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 09- ============= merge guest user cart to logged in user cart
const mergeMaskedCart = async (mage, quote, storeId, customerId) => {
  let config = {
    method: 'put',
    url: '/cart/mergeQuote/' + quote,
    headers: {
      mage: 'Bearer ' + mage,
    },
    data: JSON.stringify({ customerId, storeId }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 15- Rajhi Get Otp
const rajhiGetOtp = async (mobile_number) => {
  let config = {
    method: 'post',
    url: `/mokafa/get-otp?mobile=${mobile_number}`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 16- Rajhi Reedem
const rajhiRedeem = async (mobile, amount, pin, quoteId, referenceId) => {
  let config = {
    method: 'post',
    url: '/mokafa/applypoint',
    data: JSON.stringify({
      mobile,
      amount,
      pin,
      quoteId,
      isMask: true,
      referenceId,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const deleteProductFee = async (id, itemId) => {
  const { handshake, quote } = getCookies();
  let config = {
    method: 'post',
    url: `/multifee/removeProductFees/${quote}`,
    headers: { Authorization: `Bearer ${handshake}` },
    data: JSON.stringify({ feeData: { id, itemId } }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const clearCart = async ({ mage, quote }) => {
  let config = {
    method: 'get',
    url: `/cart/clearQuote/${quote}/${mage ? '0' : '1'}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req.data
  } catch (error) {
    return error;
  }
};

// export all functions
export {
  createCart,
  getCart,
  clearCart,
  addItemToCart,
  addMultiItemsToCart,
  updateCartItem,
  deleteCartItem,
  applyCoupon,
  deleteCoupon,
  mergeMaskedCart,
  rajhiGetOtp,
  rajhiRedeem,
  deleteProductFee,
  getCoupons,
};
